import { SocialLink } from "data";

export const socials: SocialLink[] = [
  {
    // mailto:{email address}?subject={subject}&cc={cc addresses}&body={body}
    link: 'mailto:nadinejwebdev@gmail.com',
    type: 'mail',
  },
  {
    link: 'https://github.com/nadinejuraschek',
    type: 'github',
  },
  {
    link: 'https://www.linkedin.com/in/nadinepesso/',
    type: 'linkedin',
  },
  {
    link: 'https://tidycal.com/nadinepesso/virtual-chat',
    type: 'virtualChat',
  }
];
